import { AnchoredLayer } from '@doordash/component-layer-manager';
export var buttonOverridesFromTheme = function buttonOverridesFromTheme(theme) {
  return {
    Colors: {
      ButtonFlatPrimaryForeground: theme.Colors.ToastInformationalAction,
      ButtonFlatPrimaryForegroundDisabled: theme.Colors.ToastInformationalActionDisabled,
      ButtonFlatPrimaryForegroundHovered: theme.Colors.ToastInformationalActionHovered,
      ButtonFlatPrimaryForegroundPressed: theme.Colors.ToastInformationalActionPressed
    }
  };
};
export var POSITIONS = {
  TopStart: AnchoredLayer.Positions.TopLeft,
  TopCenter: AnchoredLayer.Positions.TopCenter,
  TopEnd: AnchoredLayer.Positions.TopRight,
  BottomStart: AnchoredLayer.Positions.BottomLeft,
  BottomCenter: AnchoredLayer.Positions.BottomCenter,
  BottomEnd: AnchoredLayer.Positions.BottomRight
};
export var DURATIONS = {
  Short: 4000,
  Medium: 6000,
  Long: 10000
};